// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.port-call-details-container {
    padding: 2rem;
    background: #f8f9fa;
    border-radius: 6px;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1rem;
}

label {
    display: flex;
    flex-direction: column;
    font-weight: 600;
    font-size: 0.95rem;
    color: #222;
}

input, select {
    margin-top: 4px;
    padding: 8px;
    font-size: 0.9rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.wizard-buttons {
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;
}

    .wizard-buttons button {
        background-color: #004080;
        color: white;
        padding: 10px 20px;
        border: none;
        font-weight: bold;
        border-radius: 4px;
        cursor: pointer;
    }

        .wizard-buttons button:hover {
            background-color: #0066cc;
        }
.card {
    background: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 24px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
}

.row {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
}

.field {
    flex: 1 1 45%;
    margin-bottom: 12px;
    padding-right: 20px;
    min-width: 250px;
}

    .field label {
        font-weight: 500;
        color: #666;
    }

    .field span {
        display: block;
        margin-top: 4px;
        font-weight: 600;
        color: #222;
    }
.field-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 10px 24px;
    margin-top: 10px;
}

.field-grid-item {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    padding: 4px 0;
}

.field-label {
    font-weight: 500;
    color: #444;
}

.field-value {
    font-weight: 400;
    color: #111;
    margin-left: 10px;
    text-align: right;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #2a2a2a;
    border-bottom: 1px solid #ccc;
    padding-bottom: 6px;
    margin-bottom: 10px;
}

.section-card {
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    margin-bottom: 24px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.08);
}

.back-button {
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    padding: 6px 12px;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    margin-bottom: 16px;
}
.field-label {
    font-weight: 500;
    color: #555;
    font-size: 13px;
    display: flex;
    align-items: center;
}

.field-value {
    font-weight: 400;
    color: #111;
    font-size: 14px;
    text-align: right;
}

.info-icon {
    font-size: 16px;
    margin-right: 6px;
    color: #888;
}

.section-title {
    font-size: 17px;
    font-weight: 600;
    color: #2a3f5f;
    border-left: 4px solid #2a3f5f;
    padding-left: 12px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.section-icon {
    font-size: 20px;
    color: #2a3f5f;
}

.back-button {
    background-color: #f9f9f9;
    border: 1px solid #bbb;
    padding: 6px 14px;
    font-size: 14px;
    margin-bottom: 24px;
    border-radius: 5px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/PortCallDetailsStep.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;IAEI;QACI,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;QAEI;YACI,yBAAyB;QAC7B;AACR;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;IAEI;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;AACJ;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".port-call-details-container {\n    padding: 2rem;\n    background: #f8f9fa;\n    border-radius: 6px;\n}\n\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n    gap: 1rem;\n}\n\nlabel {\n    display: flex;\n    flex-direction: column;\n    font-weight: 600;\n    font-size: 0.95rem;\n    color: #222;\n}\n\ninput, select {\n    margin-top: 4px;\n    padding: 8px;\n    font-size: 0.9rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.wizard-buttons {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: space-between;\n}\n\n    .wizard-buttons button {\n        background-color: #004080;\n        color: white;\n        padding: 10px 20px;\n        border: none;\n        font-weight: bold;\n        border-radius: 4px;\n        cursor: pointer;\n    }\n\n        .wizard-buttons button:hover {\n            background-color: #0066cc;\n        }\n.card {\n    background: #ffffff;\n    border: 1px solid #dcdcdc;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 24px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.section-title {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 12px;\n    color: #333;\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 8px;\n}\n\n.field {\n    flex: 1 1 45%;\n    margin-bottom: 12px;\n    padding-right: 20px;\n    min-width: 250px;\n}\n\n    .field label {\n        font-weight: 500;\n        color: #666;\n    }\n\n    .field span {\n        display: block;\n        margin-top: 4px;\n        font-weight: 600;\n        color: #222;\n    }\n.field-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 10px 24px;\n    margin-top: 10px;\n}\n\n.field-grid-item {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    padding: 4px 0;\n}\n\n.field-label {\n    font-weight: 500;\n    color: #444;\n}\n\n.field-value {\n    font-weight: 400;\n    color: #111;\n    margin-left: 10px;\n    text-align: right;\n}\n\n.section-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #2a2a2a;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 6px;\n    margin-bottom: 10px;\n}\n\n.section-card {\n    background: #fff;\n    padding: 24px;\n    border-radius: 8px;\n    margin-bottom: 24px;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.08);\n}\n\n.back-button {\n    background-color: #f0f0f0;\n    border: 1px solid #ccc;\n    padding: 6px 12px;\n    font-size: 14px;\n    cursor: pointer;\n    border-radius: 4px;\n    margin-bottom: 16px;\n}\n.field-label {\n    font-weight: 500;\n    color: #555;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n}\n\n.field-value {\n    font-weight: 400;\n    color: #111;\n    font-size: 14px;\n    text-align: right;\n}\n\n.info-icon {\n    font-size: 16px;\n    margin-right: 6px;\n    color: #888;\n}\n\n.section-title {\n    font-size: 17px;\n    font-weight: 600;\n    color: #2a3f5f;\n    border-left: 4px solid #2a3f5f;\n    padding-left: 12px;\n    margin-bottom: 16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.section-icon {\n    font-size: 20px;\n    color: #2a3f5f;\n}\n\n.back-button {\n    background-color: #f9f9f9;\n    border: 1px solid #bbb;\n    padding: 6px 14px;\n    font-size: 14px;\n    margin-bottom: 24px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
